import cn from 'classnames'
import React from 'react'

//
import BackgroundImage from '../../../../public/images/pattern-grey.jpg'
import { ButtonGroup, ButtonNew, SectionHeader } from '../../../storybook'
import Image from 'next/image'
import { getUrl } from '../../../utils/urls'
import { LocationContext } from '../../page-wrapper'
import { MediaComponent } from '../crissCross/mediaComponent'
import { useRouter } from 'next/router'
import { useNavigationData } from '@/src/context/NavigationContext'

const SECTION_HEADER_BACKGROUND = {
  GRAY: 'gray',
  BLACK: 'black',
  WHITE: 'white',
  PATTERN: 'pattern'
}

const BlockSectionHeader = ({
  data: {
    icon,
    preface,
    title,
    headingType,
    shortDescription,
    primaryAction,
    secondaryAction,
    contentAlignment,
    backgroundColor,
    image,
    video,
    logo
  }
}) => {
  const router = useRouter()
  const { navigationItems } = useNavigationData()
  const location = React.useContext(LocationContext)
  const { slugPrefix } = location
  return (
    <section
      className={cn('l-section l-section--section-header u-position-relative', {
        'l-section--grey': backgroundColor === SECTION_HEADER_BACKGROUND.GRAY,
        'l-section--black': backgroundColor === SECTION_HEADER_BACKGROUND.BLACK
      })}
    >
      {
        // Set background image is Homepage is true
        backgroundColor === SECTION_HEADER_BACKGROUND.PATTERN ? (
          <div className={'c-section-header__homepage-bg u-ignore-block-gap-margin'}>
            <Image
              src={BackgroundImage}
              style={{
                width: '100%',
                objectFit: 'cover'
              }}
              alt="Background Image of Hero"
              aria-hidden={true}
            />
          </div>
        ) : null
      }
      <div
        className={cn('l-container--default-spacing', {
          'l-container:12/12': contentAlignment === 'left',
          'l-container:10/12': !contentAlignment || contentAlignment === 'center'
        })}
      >
        <SectionHeader
          key={router.asPath}
          align={contentAlignment || 'center'}
          eyebrow={preface || ''}
          title={title || ''}
          headingType={headingType}
          icon={icon || ''}
          text={shortDescription || ''}
          inverted={backgroundColor === SECTION_HEADER_BACKGROUND.BLACK}
          image={!video && image ? image : null}
          logo={logo}
        >
          {(primaryAction || secondaryAction) && (
            <ButtonGroup center>
              {primaryAction && (
                <ButtonNew
                  url={getUrl({
                    navItem: primaryAction,
                    slugPrefix: slugPrefix,
                    navigationItems: navigationItems
                  })}
                  subtext={primaryAction.subtext}
                  variant="green"
                >
                  {primaryAction.title || ''}
                </ButtonNew>
              )}
              {secondaryAction ? (
                <ButtonNew
                  variant={'secondary'}
                  url={getUrl({
                    navItem: secondaryAction,
                    slugPrefix: slugPrefix,
                    navigationItems: navigationItems
                  })}
                  subtext={secondaryAction.subtext}
                >
                  {secondaryAction.title || ''}
                </ButtonNew>
              ) : null}
            </ButtonGroup>
          )}
        </SectionHeader>
      </div>
      {video ? (
        <div
          className={cn('l-container--default-spacing', {
            'l-container:12/12': contentAlignment === 'left',
            'l-container:10/12': !contentAlignment || contentAlignment === 'center'
          })}
        >
          <MediaComponent {...{ image, wistiaVideo: video }} height={255} width={400} />
        </div>
      ) : null}
    </section>
  )
}

export default BlockSectionHeader
